import React, { Component } from 'react';
import moment from 'moment';

import { showModal } from '../actions/modal';

import { getDocLastUpdate } from '../utils/doc';

import UserName from './user-name';

import Placeholder from './placeholders/card.placeholder';

import IconNiftyDoc from '../icons/icon-nifty-doc';
import IconGoogleDocument from '../icons/icon-google-document';
import IconGoogleSpreadsheets from '../icons/icon-google-spreadsheets';
import IconGooglePresentation from '../icons/icon-google-presentation';

export default class DocCard extends Component {
    handleClick = () => {
        showModal('DOCUMENT_MODAL', {
            docId: this.props.id,
            updatedAt: this.props.updated_at
        });
    }

    getLastEditedMessage(date) {
        if (new Date() - date > 60000) {
            return `Updated on ${moment(date).format('MMM D, YYYY [at] h:mma')}`;
        } else {
            return 'Updated now';
        }
    }

    get iconElement() {
        switch (this.props.subtype) {
            case 'document':
                return <IconGoogleDocument size="40px" />;

            case 'spreadsheet':
                return <IconGoogleSpreadsheets size="40px" />;

            case 'presentation':
                return <IconGooglePresentation size="40px" />;

            default:
                return <IconNiftyDoc size="40px" />;
        }
    }

    render() {
        if (this.props.loading) {
            return <div className="discussion-card"><Placeholder /></div>;
        }

        const lastEdit = getDocLastUpdate(this.props.members, this.props.author, this.props.created_at);

        return (
            <div className="card discussion-card" onClick={this.handleClick}>
                <div className="card-main">
                    <div className="card-head">
                        <div className="card-icon">
                            { this.iconElement }
                        </div>
                    </div>

                    <div className="card-body">
                        <h4>{ this.props.name }</h4>

                        <p>
                            <small>
                                <i className="icon ion ion-android-refresh" /> {this.getLastEditedMessage(lastEdit.date)} by <UserName id={lastEdit.userId} />
                            </small>
                        </p>
                    </div>
                </div>

                <div className="card-foot">
                    <div className="card-meta">
                        <div className="item">
                            Docs
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
